import { Table } from 'react-bootstrap';

// Components
import ButtonAction from 'components/ButtonAction';
import PaginationContainer from 'components/PaginationContainer';

import { renderTableHeader } from 'components/PaginationContainer';
import { useSortableTable } from 'hooks/useSortableTable';
import useStickyHeader from 'hooks/useStickyHeader';

import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { size, cloneDeep, isNil } from "lodash"
import { filterData, SearchType } from "filter-data";
import { organizationType } from 'const/nuclias/organization';

const defaultPagination = { current: 1, pageLimit: 10 };

const columns = [
  {
    label: 'f8df07b3d1',
    accessor: 'name',
    sortable: true,
    sortbyOrder: 'asc',
  },
  {
    label: '53d2eaf15a',
    accessor: 'parentTagName',
    sortable: true,
  },
  {
    label: 'a1fa277792',
    accessor: 'orgTypleLabel',
    sortable: true,
  }
]

const OrgTreeTableView = ({
  treeData,
  handleModals,
  seachValue
}) => {
  const { t } = useTranslation();

  const { tableRef, stickyStyle } = useStickyHeader();
  const [tableData, handleSorting] = useSortableTable((treeData?.treeList || []), columns);
  const [pagination, setPagination] = useState(cloneDeep(defaultPagination));
  const [sortField, setSortField] = useState('');
  const [order, setOrder] = useState('asc');
  const [currentTableData, setCurrentTableData] = useState([]);

  useEffect(() => {
    const searchConditions = [{
      key: 'name',
      value: seachValue,
      type: SearchType.LK
    }];
    const newList = filterData(tableData, searchConditions);
    setCurrentTableData(newList)
    setPagination({ ...pagination, current: 1 })

  }, [seachValue, tableData]);

  return (
    <>
      <Table responsive striped hover className="table-container" ref={tableRef}>
        <thead style={stickyStyle}>
          <tr>
            <th>#</th>
            {renderTableHeader(columns, order, setOrder, sortField, setSortField, handleSorting)}
            <th className="table-action-th">{t('06df33001c')}</th>
          </tr>
        </thead>
        <tbody>
          {currentTableData?.length > 0 ?
            (currentTableData.slice(
              (pagination.current - 1) * pagination.pageLimit,
              (pagination.current - 1) * pagination.pageLimit + pagination.pageLimit
            ).map((item, index) => {
              return (
                <tr key={index}>
                  <td>{(pagination.current - 1) * pagination.pageLimit + index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.parentTagName}</td>
                  <td>{item.orgTypleLabel}</td>
                  <td>
                    <ButtonAction
                      label="EDIT"
                      title="EDIT"
                      iconClassName="icon-edit"
                      disabled={!item.actions?.canEdit}
                      onClick={() => handleModals({ modal: 'site', status: true, type: 'edit', editObj: {} })}
                    />
                    <ButtonAction
                      label="DELETE"
                      title="DELETE"
                      iconClassName="icon-trash"
                      disabled={!item.actions?.canDelete}
                      onClick={() => handleModals({ modal: 'delete', status: true, type: null, editObj: {} })}
                    />
                  </td>
                </tr>
              );
            }))
            : (<tr>
              <td colSpan="5" style={{ textAlign: 'center', height: 35 }}>
                {t('ad01242a61')}
              </td>
            </tr>
            )
          }
        </tbody>
      </Table>

      <PaginationContainer
        total={currentTableData?.length || 0}
        isCurrentPageId={pagination?.current || 1}
        onPageChange={currentPageNum =>
          setPagination({ ...pagination, current: currentPageNum })
        }
        onEntryLimitChange={currentPageNum =>
          setPagination({ ...pagination, pageLimit: currentPageNum })
        }
      />
    </>
  );
};

export default OrgTreeTableView;
